// Announcement bar
var announcementBar = new Swiper(".announcement-bar", {
    slidesPerView: 1,
    autoplay: true,
});

if (window.outerWidth > 749) {
  // Footer accordion script
  var footerMenuList = document.querySelectorAll(
      ".footer-block__accordion details"
  );
  footerMenuList.forEach((menuList) => {
      menuList.setAttribute("open", false);
  });
}

if (window.outerWidth < 750) {
  // Character PLP Slider
  var chracterHeroSlider = new Swiper(".collection-character__grid", {
    slidesPerView: 1.5,
    autoplay: false,
  });
}

// Header hover 
$('.header__inline-menu > ul > li').on('mouseenter', function(){
  $("main").addClass('nav-hover');
}).on('mouseleave', function(){
  $("main").removeClass('nav-hover');
})

// PDP open "Drop a hit"
$("#drop-a-hint").on('click', function(){
  $("#dropahint").trigger("click");
});

// Wonder Rewards page - Refer a friend
$("#invite-a-friend").on('click', function(e){
  e.preventDefault();
  $(".stamped-launcher-button").trigger("click");
});

//========== Cart Scripts ==========/
// Frequently Bought Together Slider
var frequentlyBoughtSwiper = new Swiper(".frequentlyBought_swiper", {
    slidesPerView: 1.6,
    spaceBetween: 10,
    autoplay: false,
    breakpoints: {
        750: {
            slidesPerView: 2.8,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        },
        1025: {
            slidesPerView: 3.2,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        },
    },
});

//========== PDP Scripts ==========//
// PDP - Code to copy the sku on click;
var skuCopy = document.querySelector('.product-sku-copy');
if(skuCopy) {
    skuCopy.addEventListener('click', function() {
        var copyTextParent = document.querySelector(".product__sku");
        navigator.clipboard.writeText(skuCopy.textContent).then(() => {
            copyTextParent.classList.add("active"); // Show feedback
            setTimeout(() => {
                copyTextParent.classList.remove("active"); // Remove feedback after 2.5 seconds
            }, 2500);
        }).catch(err => {
            console.error("Failed to copy text: ", err);
        });
    });
}

// PDP - Accordion script
const accSingleTriggers = document.querySelectorAll('.product__accordion-title');
accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));
function toggleAccordion() {
  const items = document.querySelectorAll('.product__accordion');
  const thisItem = this.parentNode;
  items.forEach(item => {
    if (thisItem == item) {
      thisItem.classList.toggle('active');
      return;
    }
    item.classList.remove('active');
  });
}
// PDP - Product image slider 
let swiperInstance;
function initSwiper() {
  if (window.innerWidth < 750) {
    if (!swiperInstance) {
      swiperInstance = new Swiper(".product__media-list-container", {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  } else {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }
}
function updateSwiper() {
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
    initSwiper();
  }
}
subscribe(PUB_SUB_EVENTS.variantData, (event) => {
  updateSwiper();
});
initSwiper();
window.addEventListener("resize", initSwiper);
// PDP - Related Products Slider
var frequentlyBoughtSwiper = new Swiper(".related-product-swiper", {
    slidesPerView: 1.6,
    spaceBetween: 10,
    autoplay: false,
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
      },
      990: {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    },
});
// SCRIPT to add localStores
// Get the body element
function setThemeBrand(){
  const bodyElement = document.body;
  const bodyClasses = bodyElement.classList;
  if (bodyClasses.contains('brand-marvel')) {
    localStorage.setItem('theme', 'marvel');
  }
  if (bodyClasses.contains('brand-starwars')) {
    localStorage.setItem('theme', 'starwars');
  }
} 
setThemeBrand();
//========== Code to prevent header search auto submit ==========//
var formSelectors = document.querySelectorAll("form.search-modal__form");
formSelectors.forEach(function(formSelector){
  formSelector.addEventListener("submit", function(event){
    setThemeBrand();
      event.preventDefault();
      var inputValue = formSelector.querySelector("#Search-In-Modal-1").value.toLowerCase();
      window.location.href = `/search?q=${inputValue}&type=product`;
  })
})

// Quick Look - Media Slider Script
if (window.outerWidth < 990) {
    var quickLookMedia = new Swiper(".quick-look__media-wrapper", {
        slidesPerView: 1,
        autoplay: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
}

$(document).ready(function(){
  // Quick look popup product load and enable popup
  $(document).on('click','.product-card__button .add-to-cart-button',function(){
      var isRedirect = $(this).data('redirect');
      if(isRedirect.length){
        window.location.href = isRedirect;
        return false;
      }
      var brandName = $(this).data("brand");
      var productHandle = $(this).closest('.shopify-product-form').data('product-handle');
      var productTemplateID = '17990587547815';
      if(brandName == 'marvel'){
        productTemplateID = "17990587515047"
      }
      $("body").css({"overflow": "hidden"});
      $.ajax({
          url: `/products/${productHandle}?section_id=template--${productTemplateID}__main`,
          type: 'GET',
          success: function(response) {
              $('#quick-view-product-load').html(response);
              $('.quick-look__popup').removeClass('hidden');
          }
      });
      return false;
  });
  $('.quick-look__popup').on('click',function(event) {
      if (event.target === this) {
          $('.quick-look__popup').addClass('hidden');
          $("body").css({"overflow": "unset"});
      }
  })
  $('.quick-look__close').on('click',function(event) {
      $('.quick-look__popup').addClass('hidden');
      $("body").css({"overflow": "unset"});
  })

  // Monthly payment page js start
  $(".payment-nav a").click(function (e) {
    e.preventDefault();
    var pay_id = $(this).attr("href");
    $(this).addClass("active").siblings().removeClass("active");

    $(pay_id).show().siblings().hide();
  });
  // Monthly payment page js end
});

// Wonder rewards swiper
// const swiperRewardsworks = new Swiper(".swiper-rewards-works", {
//   slidesPerView: 3,
//   keyboard: {
//     enabled: true,
//   },
//   breakpoints: {
//     320: {
//       slidesPerView: 1, 
//       pagination: {
//         el: ".swiper-pagination",
//         type: "bullets",
//       },
//     },
//     759: {
//       slidesPerView: 1,
//       spaceBetween: 16,
//       pagination: {
//         el: ".swiper-pagination",
//         type: "bullets",
//       },
//       freeMode: {
//         enabled: true,
//         sticky: true,
//         momentumBounce: true,
//       },
//       keyboard: {
//         enabled: true,
//       },
//       mousewheel: {
//         enabled: true,
//       },
//     },
//     991: {
//       slidesPerView: 3,
//       spaceBetween: 1,
//     },
//   },
// });
if (window.innerWidth < 750) {
  const swiperRewardsworks = new Swiper(".swiper-rewards-works", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
    },
  });
}

  const swiperRewardsmagic = new Swiper(".swiper-rewards-magic", {
    slidesPerView: 3,
    breakpoints: {
      320: {
        slidesPerView: 1, 
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
        },
      },
      759: {
        slidesPerView: 2,
        spaceBetween: 16,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
        },
        freeMode: {
          enabled: true,
          sticky: true,
          momentumBounce: true,
        },
        keyboard: {
          enabled: true,
        },
        mousewheel: {
          enabled: true,
        },
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });  

  const swiperWonderBrands = new Swiper(".swiper-wonder-brands", {
    slidesPerView: 3,
   
    breakpoints: {
      320: {
        slidesPerView: 1, 
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
        },
      },
      759: {
        slidesPerView: 2,
        spaceBetween: 16,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
        },
        freeMode: {
          enabled: true,
          sticky: true,
          momentumBounce: true,
        },
        keyboard: {
          enabled: true,
        },
        mousewheel: {
          enabled: true,
        },
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
   
  });  


  // Select all question wrappers
 const questionWrappers = document.querySelectorAll(".item-question-wrapper");

 // Open the first FAQ item on load
 const firstFaqItem = document.querySelector(".faq-item");
 if (firstFaqItem) {
   const firstAnswer = firstFaqItem.querySelector(".item-answer");
   const firstPlusIcon = firstFaqItem.querySelector(".icon-plus");
   const firstMinusIcon = firstFaqItem.querySelector(".icon-minus");

   if (firstAnswer) firstAnswer.style.display = "block";
   if (firstPlusIcon) firstPlusIcon.style.display = "none";
   if (firstMinusIcon) firstMinusIcon.style.display = "inline";
 }

 // Add click event listener to all question wrappers
 questionWrappers.forEach(wrapper => {
   wrapper.addEventListener("click", function () {
     // Close all other answers and reset their icons
     document.querySelectorAll(".faq-item").forEach(item => {
       const answer = item.querySelector(".item-answer");
       const plusIcon = item.querySelector(".icon-plus");
       const minusIcon = item.querySelector(".icon-minus");

       if (answer) answer.style.display = "none";
       if (plusIcon) plusIcon.style.display = "inline";
       if (minusIcon) minusIcon.style.display = "none";
     });

     // Toggle the clicked item's answer and icons
     const answer = this.nextElementSibling;
     const plusIcon = this.querySelector(".icon-plus");
     const minusIcon = this.querySelector(".icon-minus");

     if (answer) {
       answer.style.display = "block";
       if (plusIcon) plusIcon.style.display = "none";
       if (minusIcon) minusIcon.style.display = "inline";
     }
   });
 });